export default __webpack_public_path__ + "static/media/icon-results-dark.bd2003da.svg";